import eventsconfig from "./eventsconfig.json" with { type: "json" };

export function trackEvent(trackingId: string) {
  if (import.meta.env.VITE_STAGE === "prod") {
    if (isObjectKey(eventsconfig, trackingId)) {
      const { category, name, action } = eventsconfig[trackingId];

      if (window._paq !== undefined) {
        window._paq.push(["trackEvent", category, name, action]);
      }
    }
  }
}

function isObjectKey<ObjectType extends object>(
  object: ObjectType,
  key: string | number | symbol,
): key is keyof ObjectType {
  return key in object;
}
